<app-spinner-service></app-spinner-service>
<p-toolbar>
    <div class="p-toolbar-group-left">
    </div>
    <div class="p-toolbar-group-right">
        <span class="p-input-icon-left">
            <i class="pi pi-search"></i>
            <input pInputText type="text" (input)="applyFilterGlobal($event)" placeholder="Pesquisar" />
        </span>
    </div>
</p-toolbar>

<p-tabView>
    <p-table #dt [value]="folhasPagamentos" [paginator]="true" [rows]="10" [globalFilterFields]="['pa', 'valor']"
        currentPageReportTemplate="Mostrando {first} até {last} de {totalRecords} Folhas de pagamentos"
        [showCurrentPageReport]="true">
        <ng-template pTemplate="header">
            <tr>
                <th pSortableColumn="pa" class="text-left">
                    Período <p-sortIcon field="pa"></p-sortIcon>
                </th>
                <th pSortableColumn="valor" class="text-left">
                    Valor <p-sortIcon field="valor"></p-sortIcon>
                </th>
                <th class="text-center">Ações</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-pagamento>
            <tr>
                <td class="text-left">{{ formatCompetencia(pagamento?.pa) }}</td>
                <td class="text-left">{{ pagamento?.valor | currency:'BRL' : 'symbol' : '1.2-2' }}</td>
                <td class="text-center">
                    <button pButton pRipple icon="pi pi-pencil" pTooltip="Editar Conta Contábil" tooltipPosition="left"
                        class="mr-2 p-button-rounded" (click)="editarPagamento(pagamento)">
                    </button>

                    <button pButton pRipple icon="pi pi-times" pTooltip="Excluir Conta Contábil" tooltipPosition="left"
                        class="mr-2 p-button-rounded" severity="danger" (click)="excluirPagamento(pagamento)">
                    </button>
            </tr>
        </ng-template>
    </p-table>
</p-tabView>

<p-confirmDialog></p-confirmDialog>